module.exports = __webpack_public_path__ + "static/media/rev-right-img.078635aa.png";